import React, { createContext, useState } from 'react';
import GdsClient from '../../gds-api-client';

interface Props {
  children: any;
}

export const GdsClientContext = createContext<GdsClient>({} as GdsClient);

const GdsProvider: React.FC<Props> = ({ children }) => {
  const [gdsApi] = useState(() => new GdsClient());

  return <GdsClientContext.Provider value={gdsApi}>{children}</GdsClientContext.Provider>;
};

export default GdsProvider;
